import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-gray-100 min-h-screen" }
const _hoisted_2 = { class: "p-4 text-sm text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "pt-32 text-center text-primary-dark font-bold" }, [
      _createElementVNode("p", { class: "mb-1" }, "システムエラーが発生しました"),
      _createElementVNode("p", { class: "mb-10 text-3xl" }, "INTERNAL SERVER ERROR")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("p", null, " 申し訳ありません。お探しのページは一時的にアクセスできない状況です。しばらく経ってからアクセスしてください。 ", -1)),
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}